import {
  toColor,
  VisualPicker,
  type Color,
  type VisualPickerAction,
} from "@salestrak/ui";
import { WorkspaceAvatar } from "#app/components/brand/workspace-avatar";
import { AvatarEditTrigger } from "#app/components/settings/avatar-edit-trigger";
import type { Omittable } from "@salestrak/ui";

// Image upload has no backing yet (Workspace.settings.logo is a dead core
// stub and updateWorkspace takes no logo) — the row is shown disabled so the
// affordance is discoverable before dev builds it. A picker action has no
// tooltip slot, so the label itself says why the row does nothing.
const ACTIONS: VisualPickerAction[] = [
  { icon: "upload", label: "Upload image (coming soon)", disabled: true },
];

/**
 * The editable workspace tile: pressing it opens the VisualPicker's curated
 * palette. Takes the tile's ingredients rather than a saved workspace so the
 * create screen can preview a workspace that does not exist yet. Deliberately
 * narrower than the user ProfileAvatar's picker — no "No color" swatch (an
 * unset workspace tile is the grey default, never colorless) and no themed
 * option.
 */
export function WorkspaceAvatarPicker({
  name,
  avatarColor,
  logo,
  onColorChange,
}: Omittable<{
  name: string;
  /** Free-form from the API; narrowed here, unset renders the grey tile. */
  avatarColor?: string | null;
  logo?: string | null;
  onColorChange: (color: Color) => void;
}>) {
  return (
    <VisualPicker
      color={toColor(avatarColor) ?? "grey"}
      onColorChange={onColorChange}
      actions={ACTIONS}
      tooltip="Set workspace avatar"
      trigger={
        <AvatarEditTrigger label="Set workspace avatar" shape="square">
          <WorkspaceAvatar
            avatarColor={avatarColor}
            logo={logo}
            name={name}
            size="default"
          />
        </AvatarEditTrigger>
      }
    />
  );
}
